export default "__VITE_ASSET__$HPncfGq__"